import React from 'react';

type AppContextType = {
  routes: any[];
};
const AppContext = React.createContext<AppContextType>({ routes: [] });

export default AppContext;
